import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RestaurantsRoutingModule } from './restaurants-routing.module';
import { RestaurantsComponent } from './restaurants.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatIconModule } from '@angular/material/icon';
import { ControlsModule } from 'src/app/theme/controls/controls.module';
import { MatButtonModule } from '@angular/material/button';
import { ProductLayoutModule } from 'src/app/theme/product-layout/product-layout.module';

@NgModule({
  declarations: [
    RestaurantsComponent
  ],
  imports: [
    CommonModule,
    RestaurantsRoutingModule,
    FlexLayoutModule,
    MatIconModule,
    ControlsModule,
    MatButtonModule,
    ProductLayoutModule
  ]
})
export class RestaurantsModule { }
